import type { FaireProductEntity } from "../../entity_types/product";

export const p_8zawn3coab: FaireProductEntity = {
  token: "p_8zawn3coab",
  type: "product",
  name: "Millers Banana Pepper Sauce: Mild",
  brandToken: "b_d1rzqm9rrs",
  brandName: "Miller's Gourmet Foods, LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/5b573dd8cb484f90d08ccdb297e0abc4dd8b86630ce1b77a2814da75feab96bd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7936eef72ae43cc4a6d66c173ffdbd6992e9d9a9ebcc5fe6395104686cd270a0.jpeg",
    "https://cdn.faire.com/fastly/1369ca57fa18c711fc7003c79d5d766c325243eff2ad60501c1b121ea077de9d.jpeg",
    "https://cdn.faire.com/fastly/e269ed911533a5c3896d1a98f38576037f934afbe4691d001cad98362bf9ccb5.jpeg",
    "https://cdn.faire.com/fastly/f675733392d69725e3d7189cf276f701bfeda6f6979fcbcd292a6de3089ce32b.jpeg",
    "https://cdn.faire.com/fastly/b471472a8621b0a5998b8b6da9aa9313e2aeebf4186ff865ec8f2826a6810f06.jpeg",
    "https://cdn.faire.com/fastly/ca9ff14fd0a51f78ae5d7a9e47ce1aecd4d156c239a9978ef0b22aea8fe8b140.jpeg",
  ],
  priceDollars: 3.25,
  description:
    "Miller's Mild Banana Pepper Sauce packs the same sweet and spicy flavor that fans have grown to love, with a gentle heat profile that’s easier on your tongue.\n\nMade from scratch with fresh, whole peppers and our special blend of mustard seeds and spices.\n\nPerfect with cheese, pretzels, burgers, BBQ and more.\n\nFat-free & gluten-free. Non-GMO Project Verified.\n\nSize: 9.5 oz.\nNote: 24 bottles fills shipping case, best way to amortize shipping costs.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:14.227Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
